import React from 'react';
import { History, Play, Download, ChevronRight } from 'lucide-react';
const agents = [{
  id: '1',
  name: 'Private Equity & Ownership',
  riskLevel: 'Low',
  riskColor: 'green',
  summary: 'Still family-owned since 1971. Willy Wonka holds majority stake, Charlie Bucket has minority ownership. No recent changes or private equity involvement detected.',
  lastRun: 'May 14, 2026 3:56 PM'
}, {
  id: '2',
  name: 'Customer Reviews & Sentiment',
  riskLevel: 'Medium',
  riskColor: 'yellow',
  summary: 'Mixed reviews at 3.4/5 stars. Complaints about delayed shipments and quality issues up 23% this quarter. Golden Ticket fans still love the brand, but newer customers cite communication problems.',
  lastRun: 'May 14, 2026 1:33 PM'
}, {
  id: '3',
  name: 'Legal, Litigation & Public Records',
  riskLevel: 'High',
  riskColor: 'red',
  summary: 'Active lawsuit from Slugworth Confections seeking $340K for breach of distribution contract. Three OSHA workplace safety citations issued in March 2026.',
  lastRun: 'May 13, 2026 2:15 PM'
}];
function RiskBadge({
  level,
  color
}: {
  level: string;
  color: string;
}) {
  const bgColor = color === 'green' ? 'bg-green-100 text-green-800 border-green-300' : color === 'yellow' ? 'bg-yellow-100 text-yellow-800 border-yellow-300' : 'bg-red-100 text-red-800 border-red-300';
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${bgColor}`} data-id="element-4326" data-mp="1gauy6apnkchq">
      {level}
    </span>;
}
export function WonkaResearchAgentsTab() {
  return <div className="space-y-6" data-id="element-4327" data-mp="1qalqq6unkhf6">
      {/* Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-4328" data-mp="1v9gja0if9kch">
        <div className="flex items-center justify-between" data-id="element-4329" data-mp="3s1717oerexmj">
          <p className="text-sm text-gray-600" data-id="element-4330" data-mp="3s31jsw2k6dng">
            Click Run All to start the agents, or run them individually.
          </p>
          <div className="flex items-center gap-3" data-id="element-4331" data-mp="3ozm1j1mtfpwa">
            <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-4332" data-mp="3p044eh3zh2d6">
              <History className="w-4 h-4" data-id="element-4333" data-mp="2snqfz3z4cbr" />
              HISTORY
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-4334" data-mp="3ty5nh21et1on">
              <Play className="w-4 h-4" data-id="element-4335" data-mp="bqzd5q1pypyx" />
              RUN ALL
            </button>
          </div>
        </div>
      </div>

      {/* Risk Summary */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-4336" data-mp="lj57h6fg1jha">
        <div className="p-6 border-b border-gray-200 flex items-center justify-between" data-id="element-4337" data-mp="gjipyksl1h2o">
          <div className="flex items-center gap-3" data-id="element-4338" data-mp="uj20fk8v94i5">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-4339" data-mp="ujtma3cnvnv8">Risk Summary</h2>
            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800 border border-yellow-300" data-id="element-4340" data-mp="qj9kgmh57w2r">
              Medium
            </span>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-4341" data-mp="1e4kbh8yugym2">
            <Download className="w-4 h-4" data-id="element-4342" data-mp="153m54k0xof0b" />
            EXPORT CSV
          </button>
        </div>

        {/* Agents Table */}
        <div className="overflow-x-auto" data-id="element-4343" data-mp="qe7rv0u8ldfn">
          <table className="w-full text-left border-collapse" data-id="element-4344" data-mp="v67punqqxw9l">
            <thead data-id="element-4345" data-mp="v7smqk0j9ram">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-4346" data-mp="hf2wu4hvw288">
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 w-1/5" data-id="element-4347" data-mp="hgnp1ngq792x">
                  Agent
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 w-32 text-center" data-id="element-4348" data-mp="7gww3q7td24y">
                  Risk Level
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-4349" data-mp="ceyesa1buzfw">
                  Summary
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 w-48 text-center" data-id="element-4350" data-mp="1esmh0jqevaxi">
                  Last Run
                </th>
                <th className="px-6 py-3 w-12" data-id="element-4351" data-mp="160u9ohwoohx5"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-4352" data-mp="11210v2scdf3b">
              {agents.map(agent => <tr key={agent.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-4353" data-mp="w2wltviqkn52">
                  <td className="px-6 py-4" data-id="element-4354" data-mp="r31yg1y66for">
                    <span className="font-semibold text-gray-900" data-id="element-4355" data-mp="r6699i6549oe">
                      {agent.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-4356" data-mp="i46pii3qqrhr">
                    <div className="flex justify-center" data-id="element-4357" data-mp="2hg9bbyzu7xyl">
                      <RiskBadge level={agent.riskLevel} color={agent.riskColor} data-id="element-4358" data-mp="2hfr64cv769ej" />
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-4359" data-mp="2k05tkvafw3f9">
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-4360" data-mp="2oziirmos9ml0">
                      {agent.summary}
                    </p>
                  </td>
                  <td className="px-6 py-4" data-id="element-4361" data-mp="2tra8xw411qam">
                    <div className="flex items-center justify-center gap-2 text-sm text-gray-600" data-id="element-4362" data-mp="2yq3e9195uazp">
                      <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-4363" data-mp="212cs7xfgs1jz"></span>
                      {agent.lastRun}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-4364" data-mp="262r2lm4jfnl6">
                    <button className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-4365" data-mp="2azr6bqdx0e94">
                      <ChevronRight className="w-5 h-5 text-gray-400" data-id="element-4366" data-mp="2f1umutffy919" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}